<template>
    <div>
        <section name="hero-section">
            <PageHomeHeroSection />
        </section>

        <Container>
            <section class="z-10 relative bg-accent-foreground" name="latest-products">
                <PageHomeProductsTrends />
            </section>
        </Container>
    </div>
</template>

<script lang="ts" setup></script>

<style></style>
